/* SP Collection — barra de filtros (diseño Soft):
   [ Filtros ] [ pills aplicados ] .......... [ Ordenar ]
   - Botón "Filtros" colapsa la columna de facetas; el grid se ensancha a todo el ancho.
   - Reubica los pills de filtros aplicados (nativos, del sidebar) dentro de la barra.
   - Robusto a los re-render AJAX de <results-list> vía MutationObserver.
   - Estado persistido en sessionStorage para sobrevivir a los re-render/navegación. */
(function () {
  var HIDDEN_KEY = 'sp_filters_hidden';
  // Textos traducidos: llegan como data-* en la etiqueta <script> (locales del tema).
  var script = document.currentScript;
  var LABEL_FILTERS = (script && script.getAttribute('data-label-filters')) || 'Filtros';
  var LABEL_CLEAR_ALL = (script && script.getAttribute('data-label-clear-all')) || 'Limpiar todo';
  var hidden = false;
  try { hidden = sessionStorage.getItem(HIDDEN_KEY) === '1'; } catch (e) {}

  var BTN_HTML =
    '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 6h16M7 12h10M10 18h4"/></svg><span></span>';

  function stickyTop() {
    var hg = document.querySelector('#header-group');
    if (!hg) return 0;
    var top = parseFloat(getComputedStyle(hg).top) || 0;
    return Math.max(0, Math.round(hg.offsetHeight + top));
  }

  function apply() {
    var wrap = document.querySelector('.collection-wrapper');
    if (!wrap) return;
    wrap.classList.toggle('sp-filters-hidden', hidden);
    var btn = wrap.querySelector('.sp-filters-toggle');
    if (btn) {
      btn.classList.toggle('is-active', hidden);
      btn.setAttribute('aria-pressed', hidden ? 'true' : 'false');
    }
  }

  function setup() {
    var wrap = document.querySelector('.collection-wrapper');
    if (!wrap) return;
    var bar = wrap.querySelector('.facets--horizontal');
    if (!bar) return;

    bar.style.setProperty('--sp-bar-top', stickyTop() + 'px');

    // Botón Filtros (crear una vez, siempre al inicio de la barra).
    var btn = bar.querySelector('.sp-filters-toggle');
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sp-filters-toggle';
      btn.innerHTML = BTN_HTML;
      btn.querySelector('span').textContent = LABEL_FILTERS;
      btn.addEventListener('click', function () {
        // Móvil/tablet: no hay columna lateral → el botón abre el drawer de filtros nativo.
        if (window.matchMedia('(max-width: 989px)').matches) {
          var nativeBtn = document.querySelector('.facets-toggle__button, facets-toggle button, .facets-toggle button');
          if (nativeBtn) nativeBtn.click();
          return;
        }
        // Desktop: colapsar/expandir la columna de facetas.
        hidden = !document.querySelector('.collection-wrapper').classList.contains('sp-filters-hidden');
        apply();
        try { sessionStorage.setItem(HIDDEN_KEY, hidden ? '1' : '0'); } catch (e) {}
      });
      bar.insertBefore(btn, bar.firstChild);
    }

    // Reubicar los pills de filtros aplicados (nativos) dentro de la barra, tras el botón.
    var pills = wrap.querySelector('.facets-remove');
    if (pills && pills.parentElement !== bar) {
      bar.insertBefore(pills, btn.nextSibling);
    }

    // "Limpiar todo" tras los pills (el nativo queda oculto en algunos estados de Horizon).
    var remove = bar.querySelector('.facets-remove');
    if (remove && remove.querySelector('.facets-remove__pill')) {
      if (!remove.querySelector('.sp-clear-all')) {
        var native = remove.querySelector('[ref="clearButton"], .facets__clear-all-link, .facets__clear-all');
        var withUrl = native ? native.closest('[data-url]') : null;
        var link = document.createElement('a');
        link.className = 'sp-clear-all';
        link.href = withUrl ? withUrl.getAttribute('data-url') : window.location.pathname;
        link.textContent = LABEL_CLEAR_ALL;
        remove.appendChild(link);
      }
    }

    // Al mover los pills fuera del <form>, el handler nativo de "quitar filtro" deja de
    // funcionar. Navegamos por data-url (cada pill/"limpiar todo" trae la URL resultante).
    if (bar.dataset.spRemoveBound !== '1') {
      bar.dataset.spRemoveBound = '1';
      bar.addEventListener('click', function (e) {
        var el = e.target.closest('[data-url]');
        if (el && bar.contains(el)) {
          e.preventDefault();
          window.location.href = el.getAttribute('data-url');
        }
      });
    }

    apply();
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; setup(); });
  }

  function init() {
    setup();
    var target = document.querySelector('results-list') || document.querySelector('.collection-wrapper');
    if (target) {
      new MutationObserver(schedule).observe(target, { childList: true, subtree: true });
    }
    window.addEventListener('resize', function () {
      var bar = document.querySelector('.facets--horizontal');
      if (bar) bar.style.setProperty('--sp-bar-top', stickyTop() + 'px');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
